'use client';

import { styled } from '../../../styles';

export const SortedHeadCellContainer = styled('div')(
  () =>
    ({
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      cursor: 'pointer',
    } as const),
);

export const SortedHeadCellIconContainer = styled.div<{ active?: boolean }>(
  ({ theme, active }) => ({
    svg: {
      color: active ? theme.palette.text4 : theme.palette.text3,
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginLeft: theme.spacing(2),
    },
  }),
);
